module.exports = __webpack_public_path__ + "static/BrandonGrotesque-ExtraBoldItalic-257c12b3bf09e8ce57487d1e2b189c1f.ttf";